// extracted by css-extract-rspack-plugin
export default {"wrapper":"CallToActionItem-module__wrapper__GNi7G","feedbackLink":"CallToActionItem-module__feedbackLink__gI6Yv"};